/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIType } from './APIType';
import {
    APITypeFromJSON,
    APITypeFromJSONTyped,
    APITypeToJSON,
} from './APIType';

/**
 * 
 * @export
 * @interface APIPaginatedTypeList
 */
export interface APIPaginatedTypeList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedTypeList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedTypeList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedTypeList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIType>}
     * @memberof APIPaginatedTypeList
     */
    results: Array<APIType>;
}

/**
 * Check if a given object implements the APIPaginatedTypeList interface.
 */
export function instanceOfAPIPaginatedTypeList(value: object): value is APIPaginatedTypeList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedTypeListFromJSON(json: any): APIPaginatedTypeList {
    return APIPaginatedTypeListFromJSONTyped(json, false);
}

export function APIPaginatedTypeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedTypeList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APITypeFromJSON)),
    };
}

export function APIPaginatedTypeListToJSON(value?: APIPaginatedTypeList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APITypeToJSON)),
    };
}

